import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

/**
 * Always-visible marker on staging builds so nobody mistakes staging for
 * prod. Rendered only when APP_VARIANT=staging (see App.tsx).
 */
export default function StagingBanner() {
  const insets = useSafeAreaInsets();
  return (
    <View pointerEvents="none" style={[styles.wrap, { top: insets.top + 2 }]}>
      <Text style={styles.label}>STAGING</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    position: 'absolute',
    right: 8,
    backgroundColor: '#C2410C',
    borderRadius: 4,
    paddingHorizontal: 6,
    paddingVertical: 2,
    zIndex: 1000,
  },
  label: { color: '#FFFFFF', fontSize: 10, fontWeight: '700', letterSpacing: 1 },
});
